import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Query, Result } from "../../../../interfaces";
import { Find } from "../../../events";
import { Adapter } from "../../../../shared/adapter";
import { EventsAdapter } from "../../../../adapter/events-adapter";

export const FETCH_DATA_EVENTS_REQUEST = "FETCH_DATA_EVENTS_REQUEST";
export const FETCH_DATA_EVENTS_SUCCESS = "FETCH_DATA_EVENTS_SUCCESS";
export const FETCH_DATA_EVENTS_FAILURE = "FETCH_DATA_EVENTS_FAILURE";

interface ActionPagination<T> {
  type: string;
  payload: T;
}

const fetchDataEventsRequest = () => {
  return {
    type: FETCH_DATA_EVENTS_REQUEST,
  };
};

const fetchDataEventsSuccess = (data: any): ActionPagination<Result<any>> => {
  return {
    type: FETCH_DATA_EVENTS_SUCCESS,
    payload: data,
  };
};

const fetchDataEventsFailure = (error: any) => {
  return {
    type: FETCH_DATA_EVENTS_FAILURE,
    payload: error,
  };
};

export const find = (page: number, pageSize: number, query: Query) => {
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch(fetchDataEventsRequest());
    try {
      const response = await Find("events", query, page, pageSize);
      console.log(
        "events",
        Adapter.from(response.data).to((value) =>
          new EventsAdapter(value).adapt()
        )
      );
      dispatch(
        fetchDataEventsSuccess({
          meta: response.meta,
          values: Adapter.from(response.data).to((value) =>
            new EventsAdapter(value).adapt()
          ),
        })
      );
    } catch (error: any) {
      dispatch(fetchDataEventsFailure(error.message));
    }
  };
};
